import React, { PropsWithChildren } from "react";

type PropTypes = PropsWithChildren & {
  value: [number, number];
  minMaxValues: [number, number];
  units: string;
  minMaxLabels?: boolean;
  dataTestId?: string;
};

export const SearchInputLabel: React.FC<PropTypes> = ({
  children,
  value,
  units,
  minMaxLabels,
  minMaxValues,
  dataTestId,
}) => {
  const leftValue = minMaxLabels
    ? minMaxValues[0] === value[0]
      ? "min"
      : value[0]
    : value[0];
  const rightValue = minMaxLabels
    ? minMaxValues[1] === value[1]
      ? "max"
      : value[1]
    : value[1];

  return (
    <div className="flex justify-between text-sm" data-testid={dataTestId}>
      <label className="font-bold">{children}</label>
      <div data-testid={`${dataTestId}Value`}>
        <b>
          {leftValue} - {rightValue}
        </b>{" "}
        {units}
      </div>
    </div>
  );
};
